import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function ReportsIcon({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.uiLight,
}: ISvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fill="none" d="M0 0h24v24H0z" />
      <g fill={color}>
        <path d="M5 19V3.001H3V21h18v-2z" />
        <path d="M16 6.001h4V18h-4zM11 12h4v6h-4zM6 10h4v8H6z" />
      </g>
    </svg>
  );
}
